import { TEST_ASSIGNMENT_ROUTES } from './pages/test-assignment/test-assignment.routes';
import { MainComponent } from '@qima-labs/app/pages/main/main.component';
import { REPORT_GENERATION_ROUTES } from '@qima-labs/app/pages/report-generation/report-generation.routes';
import { TEMPLATE_ROUTES } from '@qima-labs/app/pages/template/template.routes';
import { TEST_SETUP_ROUTES } from '@qima-labs/app/pages/test-set-up/test-setup.routes';
import { ERouters } from '@qima-labs/app/shared/models/enums/routers.enum';
import { Route } from '@angular/router';

export const APP_ROUTES: Route[] = [
  {
    path: 'login',
    pathMatch: 'full',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/account/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'callback',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/account/callback/callback.component').then(m => m.CallbackComponent),
  },

  {
    path: '',
    redirectTo: `/${ERouters.REPORT_PREPARATION}`,
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: `${ERouters.TO_DO_LIST}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/to-do-list/to-do-list.component').then(m => m.ToDoListComponent),
      },
      {
        path: `${ERouters.DASHBOARD}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: `${ERouters.REPORT_PREPARATION}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadChildren: () => Promise.resolve(TEST_ASSIGNMENT_ROUTES),
      },
      {
        path: `${ERouters.REPORT_GENERATION}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadChildren: () => Promise.resolve(REPORT_GENERATION_ROUTES),
      },
      {
        path: `${ERouters.TEMPLATE}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadChildren: () => Promise.resolve(TEMPLATE_ROUTES),
      },
      {
        path: `${ERouters.TEST_SET_UP}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadChildren: () => Promise.resolve(TEST_SETUP_ROUTES),
      },
    ],
  },
  {
    path: `${ERouters.VIEW_SPECIMEN}/:id/:orderId`,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/test-assignment/pages/generate-breakdown-list/shared/components/view-specimen/view-specimen.component').then(m => m.ViewSpecimenComponent),
  },
  {
    path: `${ERouters.REFERENCE_SPECIMEN}/:id/:orderId`,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () =>
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      import('./pages/test-assignment/pages/edit-specimen/shared/components/reference-specimen/reference-specimen.component').then(m => m.ReferenceSpecimenComponent),
  },
  {
    path: `${ERouters.REPORT_PREPARATION}/${ERouters.SCAN}`,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/test-assignment/pages/scan/scan.component').then(m => m.ScanComponent),
  },

  {
    path: 'unauthorized',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./shared/components/page-no-access/page-no-access.component').then(m => m.PageNoAccessComponent),
  },
  {
    path: 'error',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./shared/components/page-error/page-error.component').then(m => m.PageErrorComponent),
  },
  {
    path: '**',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./shared/components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
  },
];
